import React from 'react';
import { useState, useEffect } from 'react';
import Icon from '@ant-design/icons';
import GridDisplaySvg from '../../assets/svg/GridDisplaySvg';
import ListDisplaySvg from '../../assets/svg/ListDisplaySvg';
import CountriesByOrganization from '../../components/Locations/CountriesByOrganization';
import './index.scss';
import CountryService from '../../domain/Country/CountryService';
import LocationsContext from './context';
import { CountryOrganization } from '@/domain/Country/Country';
import { useNavigate } from 'react-router-dom';

const countryService = new CountryService();

const LocationsView: React.FC = () => {
  // const locationsCtx = useContext(LocationsContext)
  const [displayMode, setDisplayMode] = useState('table');
  const [countriesToList, setCountriesToList] = useState<CountryOrganization[]>(
    [],
  );
  const navigate = useNavigate();
  function searchCountries(search: string) { }
  async function fetchCountriesToList() {
    const security = localStorage.getItem('security');
    console.log('🚀 ~ fetchCountriesToList ~ security:', security);
    if (!security) return;
    const organizationId = JSON.parse(security).organizationId;
    console.log('🚀 ~ fetchCountriesToList ~ organizationId:', organizationId);
    const res = await countryService.getCountriesByOrganization(organizationId);
    setCountriesToList(res);
  }
  useEffect(() => {
    fetchCountriesToList();
    return () => { };
  }, []);

  const prueba = import.meta.env.VITE_PRUEBA;

  return (
    <LocationsContext.Provider
      value={{ countriesByOrganization: countriesToList }}
    >
      <div className="flex column">
        <span className="text-title-page mb-4">Regions</span>
        <span>{prueba}</span>
        <div className="flex justify-between">
          <span>
            Locations are geographical areas within a Region that can be
            individually selected in the dashboard. You have locations in the
            following Regions:
          </span>
          {countriesToList.length > 0 && (
            <div>
              <Icon
                onClick={() => {
                  setDisplayMode('table');
                }}
                component={ListDisplaySvg}
                className={`cursor-pointer ${displayMode === 'table' ? 'filter-to-blue' : ''
                  }`}
                style={{ marginRight: '20px' }}
                rev={undefined}
              />
              <Icon
                onClick={() => {
                  setDisplayMode('grid');
                }}
                component={GridDisplaySvg}
                className={`cursor-pointer ${displayMode === 'grid' && 'filter-to-blue'
                  }`}
                rev={undefined}
              />
            </div>
          )}
        </div>
        <div className="container-content flex w-full justify-center">
          <CountriesByOrganization displayMode={displayMode} />
        </div>
      </div>
    </LocationsContext.Provider>
  );
};

export default LocationsView;
